import React, { useState } from 'react'
import Routes from "./Routes"
import { Avatar, Divider, Layout, Menu, } from 'antd';
import { items } from './SidebarItems';
import { useAuthContext } from 'contexts/AuthContext';
import { useLocation } from 'react-router-dom';

const { Content, Sider } = Layout;

export default function Dashboard() {
    const { user } = useAuthContext()
    const [collapsed, setCollapsed] = useState(false);
    const { pathname } = useLocation();
    const selectedKey = pathname?.split('/')?.pop();
    // console.log('selectedKey', selectedKey)
    return (
        <div className="container my-5 overflow-hidden">
            <Layout className='bg-transparent'>
                <Sider breakpoint='lg' className='card border-0 shadow my-4 p-0' collapsed={collapsed} onCollapse={(value) => setCollapsed(value)} style={{ backgroundColor: 'white' }}>
                    <div className={`text-center p-4 ${collapsed ? 'd-none' : 'd-flex flex-column align-items-center'}`}>
                        <Avatar src={user.avatar ? user.avatar : ""} alt="User Avatar" className="mb-3" style={{ width: '80px', height: '80px', objectFit: 'cover', border: '2px solid #ddd', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', }} />
                        <h5 className="mb-0">Hello, {user.firstName}!</h5>
                        <Divider />
                    </div>
                    <Menu theme="light" defaultSelectedKeys={[selectedKey]} mode="inline" items={items} />
                </Sider>
                <Layout className='p-3 bg-transparent'>
                    <Content className='p-3 bg-transparent'>
                        <Routes />
                    </Content>
                </Layout>
            </Layout>
        </div>
    )
}
